import { render, staticRenderFns } from "./QuickStarts.vue?vue&type=template&id=82aca250&"
import script from "./QuickStarts.vue?vue&type=script&lang=js&"
export * from "./QuickStarts.vue?vue&type=script&lang=js&"
import style0 from "./QuickStarts.vue?vue&type=style&index=0&id=82aca250&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports